import { getMessaging, getToken, isSupported } from "firebase/messaging";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase";

const VAPID_KEY = "BMKkuPxL22fb_gs9VMfg5Nl8QVQzRA348JsHKgXAVCDcyI5Aa6TZ3zHFRYa2Nk_x_CnuYonZhJtpBuEbNH0_aRY";

export async function registerPushToken(user) {
  try {
    if (!user?.uid) return null;

    // 🔒 Only run on HTTPS or localhost
    const isSecure =
      window.location.protocol === "https:" ||
      window.location.hostname === "localhost";

    if (!isSecure) {
      console.warn("Push skipped: requires HTTPS or localhost.");
      return null;
    }

    // 🔒 Check browser support
    const supported = await isSupported();
    if (!supported) return null;

    if (!("serviceWorker" in navigator)) return null;
    if (!("PushManager" in window)) return null;
    if (!("Notification" in window)) return null;

    // 🔒 Permission
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("Push permission denied.");
      return null;
    }

    // 🔒 Ensure service worker is ready
    const registration = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js"
    );

    await navigator.serviceWorker.ready;

    const messaging = getMessaging();

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration,
    });

    if (!token) return null;

    // ✅ Save token safely
    await setDoc(
      doc(db, "users", user.uid, "pushTokens", token),
      {
        token,
        platform: "web",
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );

    console.log("Push token registered");
    return token;

  } catch (error) {
    // 🔇 Silent failure (important for production UX)
    console.warn("Push skipped:", error?.message || error);
    return null;
  }
}